module.exports = __webpack_public_path__ + "img/lowAltitude2.a0b9548a.jpg";